import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as toastrReducer } from 'react-redux-toastr';
import { authReducer } from './auth';
import { accessibilityNotificationReducer, titleReducer } from './common';
import { portalSetupReducer } from './portal-setup';

const rootReducer = combineReducers({
  toastr: toastrReducer,
  accessibilityNotifications : accessibilityNotificationReducer,
  title: titleReducer,
  auth: authReducer,
  routing: routerReducer,
  portalSetup : portalSetupReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// src/root-reducer.js